import * as React from 'react';
import { State } from '~/store/types';

import { Button, Modal } from '@watcherr/ui';

import { t } from '~/i18n';
import connect from '~/store/connect';
import UserProfileEntry from '~store/Profile/UserProfileEntry';
import Alert from '~store/Alert/Alert';
import { useNavigate } from 'react-router-dom';

interface AlertCancelledContainerProps {
  alert: Alert;
  cancelledAlerts: Alert[];
  ownUser: UserProfileEntry;
}

const AlertCancelledContainer: React.FC<AlertCancelledContainerProps> = ({ alert }) => {
  const navigate = useNavigate();
  const wasCancelled = React.useRef(alert.isCancelled);
  const [showModal, setShowModal] = React.useState(false);
  React.useEffect(() => {
    if (!wasCancelled.current && alert.isCancelled) {
      setShowModal(true);
    }
    wasCancelled.current = alert.isCancelled;
  }, [alert.isCancelled]);

  if (!showModal) {
    return null;
  }
  return (
    <Modal style={{ maxWidth: 400 }} center>
      <h3 className="text-center mb-30">{t('alert.cancelled.title')}</h3>
      <p className="mb-30">{t('alert.cancelled.description')}</p>
      <Button onClick={() => navigate('/alerts')}>{t('alert.cancelled.goBack')}</Button>
    </Modal>
  );
};

export default connect((state: State) => ({
  cancelledAlerts: state.alerts.cancelledAlerts,
  ownUser: state.auth.user,
}))(AlertCancelledContainer);
